import type {
  CurrencyOption,
  FormStep,
} from '@/features/withdraw-bank-transfer';

export const getMinAmount = (
  currentStep?: FormStep,
  selectedCurrency?: CurrencyOption
) => {
  if (selectedCurrency && selectedCurrency.min > 0) {
    return +selectedCurrency.min;
  } else if (currentStep?.minAmount != null) {
    return +currentStep.minAmount;
  }

  return 0;
};
